// in src/MyAppBar.js
import * as React from 'react';




import { TextField } from '@material-ui/core';

import { AccordionSummary } from '@material-ui/core'


import { AppBar } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Logo from './Logo';
import MyUserMenu from './MyUserMenu';

import PostQuickCreateButton from "./MySignIn"


const useStyles = makeStyles({
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    // backgroundColor:"black"         
  },
  spacer: {
    flex: 1,

  },

  spacer2: {
    
paddingLeft:25,
  },

  main: {
    backgroundColor: "black"
  },
  dialog: {
    position: 'absolute',
    left: 10,
    top: 50
  },
  root: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 48,
    padding: '0 30px',
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  },


});

const MyAppBar = props => {
  const classes = useStyles();
  return (
    <AppBar {...props} className={classes.main} userMenu={<MyUserMenu />} >
      <span className={classes.spacer2} />
      <Logo />


      <span className={classes.spacer} />
      <PostQuickCreateButton {...props} />

    </AppBar>
  );
};

export default MyAppBar;

